import type { ReactNode } from 'react'

interface Props {
  label: string
  open: boolean
  onToggle: () => void
  children: ReactNode
}

/**
 * The collapsed-by-default block the worker sheets are built from. Extracted from the former
 * `TimeAdjustDisclosure` so the chevron, the hit area and the wording stay identical across
 * "Zeiten anpassen" and "Kommentar" — three copies of this markup had already started to drift.
 */
export function Disclosure({ label, open, onToggle, children }: Props) {
  return (
    <div className="mt-1">
      <button
        type="button"
        onClick={onToggle}
        aria-expanded={open}
        className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-700 transition-colors"
      >
        <svg
          className={`w-4 h-4 transition-transform ${open ? 'rotate-180' : ''}`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
          aria-hidden="true"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
        {label}
      </button>

      {open && <div className="mt-2">{children}</div>}
    </div>
  )
}
